import React, { useState } from 'react';
import { Grid, MenuItem, Modal, Select } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { TInpteSelectItem } from '../../../types/common';
import { ModalCancelButton, ModalSubmitButton } from './style/style';

type Tprops = {
  moveFolder: any;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  folderList: TInpteSelectItem[];
  getSelectedLists: any;
  name: string;
};

export const MoveFolderModal: React.FC<Tprops> = (props: Tprops) => {
  const {
    moveFolder,
    modalOpen,
    setModalOpen,
    folderList,
    getSelectedLists,
    name
  } = props;

  const classes = useStyles();

  const [folderId, setFolderId] = useState<number>();

  const onChange = (val: any) => {
    setFolderId(val.target.value);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div className={classes.modalHeader}>
            <h1 className={classes.modalTitle}>{name}を移動</h1>
            <p>選択した{name}をどのフォルダに移動しますか？</p>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <div className={classes.container}>
                <div className={classes.label}>フォルダ名</div>
                <Select className={classes.select} onChange={onChange}>
                  {folderList.map((listData: TInpteSelectItem) => (
                    <MenuItem value={listData.id}>{listData.name}</MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
          </div>
        </Grid>

        <div className={classes.body}>
          <Grid container justify={'center'}>
            {getSelectedLists()}
          </Grid>
        </div>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setModalOpen(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalSubmitButton
            variant='contained'
            onClick={() => {
              if (folderId) {
                moveFolder(folderId);
                setModalOpen(false);
              }
            }}
          >
            移動する
          </ModalSubmitButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '80%',
      maxHeight: '90vh',
      overflowY: 'scroll'
    },
    label: {
      width: '100px',
      textAlign: 'left',
      fontSize: 14
    },
    header: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(2, 2, 0, 0)
    },
    modalHeader: {
      width: '100%',
      textAlign: 'center',
      paddingBottom: 23,
      borderBottom: '1px solid #e6e6e6'
    },
    modalTitle: {
      fontWeight: 'bold',
      margin: 24,
      fontSize: 16
    },
    headerText: {
      fontSize: 20,
      marginTop: 10,
      marginBottom: 10
    },

    body: {
      backgroundColor: theme.palette.background.paper,
      width: '100%'
    },
    bodyListArea: {
      maxHeight: '300px',
      width: '100%',
      padding: theme.spacing(5)
    },

    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #e6e6e6',
      padding: 30
    },
    select: {
      width: 407,
      height: 40,
      backgroundColor: '#fff',
      borderRadius: 3,
      border: '1px solid #b0bcc7',
      borderBottom: 'none'
    }
  })
);
